import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { DELETE_URL } from '@utils/api/endpoints.ts';
import { AxiosError } from 'axios';
import { BaseError } from '@utils/types/shared/base.ts';

export function useDeleteResellerToken(customerId: number) {
  const queryClient = useQueryClient();

  return useMutation<void, AxiosError<BaseError>, number>(
    async (tokenId: number) => {
      await Axios.delete(
        `${DELETE_URL(customerId.toString(), tokenId.toString()).deleteResellerToken}`
      );
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries('resellerTokens');
      },
      onError: () => {},
      useErrorBoundary: false
    }
  );
}
